// extracted by mini-css-extract-plugin
export default {"iconContainer":"exPanelSoMe_iconContainer__LAy6E","iconAndLinkWrapper":"exPanelSoMe_iconAndLinkWrapper__e8e7i","icon":"exPanelSoMe_icon__vD0wU"};